import React from 'react';
import { Polyline } from 'react-leaflet';
import { SlopeDistanceLinePoint } from '../../../../../../../../core/types/types';

interface SlopeeDistanceLinesProps {
    slopeDistanceLinePoints: SlopeDistanceLinePoint[];
}
const SlopeeDistanceLines: React.FC<SlopeeDistanceLinesProps> = ({ slopeDistanceLinePoints }) => {
    return (
        <>
            {slopeDistanceLinePoints.map((points: SlopeDistanceLinePoint) => {
                if (
                    points.highest.lat !== 0 &&
                    points.highest.lng !== 0 &&
                    points.lowest.lat !== 0 &&
                    points.lowest.lng !== 0 &&
                    points.highest.elevation !== points.lowest.elevation
                ) {
                    return (
                        <Polyline
                            positions={[
                                [points.highest.lat, points.highest.lng],
                                [points.lowest.lat, points.lowest.lng],
                            ]}
                            dashArray="10"
                            weight={2}
                            color={points.color}
                        />
                    );
                } else return <></>;
            })}
        </>
    );
};

export default SlopeeDistanceLines;
